module.exports = __webpack_public_path__ + "static/img/img-products-2.ba9cd4b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/img-products-2.png
// module id = 150
// module chunks = 2